export default __webpack_public_path__ + "827a50c054ee16e2b382449d5757eb8d.svg";